import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import HourTypeFormatter from './HourTypeFormatter.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      align: 'center',
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'price',
      label: i18n.t('labor.hour_value'),
      minWidth: 110,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        const prev = row.price_format === '$' ? row.price_format : '';
        const after = row.price_format === '%' ? row.price_format : '';

        return `${prev}${Formatter.formatNumber(
          Number(row[column.property])
        )}${after}`;
      },
    },
    {
      prop: 'hour_type',
      label: i18n.t('labor.hour_format'),
      minWidth: 120,
      sortable: true,
      align: 'center',
      formatter: HourTypeFormatter,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable